import { B24Form } from '@/features/b24/b24-init-script'

import styles from './B2bFormModal.module.scss'

export const B2bFormModal = (): JSX.Element => (
	<div className={styles.modalContent}>
		<B24Form source="https://24.nbcom.ru/upload/crm/form/loader_48_diajo9.js" dataB24Form="inline/48/diajo9" />
	</div>
)
